
//import './App.css';
//import 'bootstrap/dist/css/bootstrap.min.css';

import React  from 'react';
import { useState, useEffect ,createContext} from "react";
import { Grid , Box } from '@mui/material/';

//import useMediaQuery from '@mui/material/useMediaQuery';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';  // <== ici
import CssBaseline from '@mui/material/CssBaseline';
//import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter   } from 'react-router-dom';
//import { BrowserRouter } from 'react-router-dom';

//import Members from './components/members/member';
//import Menu from './components/menu/menu';
//import Layout from '../../hoc/Layout/Layout';



import Footer from './components/footer/footer';

import Myroutes from './containers/routes/myRoutes';
import Menu from './containers/menu/oimenu';
import UserContext from "./containers/home/authContext";
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

import theme  from './theme/theme'; // ton fichier plus haut

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}


export default function App() {

  //const prefersDarkMode = useMediaQuery('(prefers-color-scheme: light)');
  const [themeMode, setThemeMode] = useState('light');
  const [userEmail, setUserEmail] = useState('Pas connecté.');
  //const [userEmail, setUserEmail] = useState('');
  //const BASE_URL = process.env.REACT_APP_BASE_URL;
   //const theme = React.useMemo(() => getTheme('light'), [themeMode]);
/*
  const theme1 = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: theme,
        },
      }),
    [theme],
  );
  */

  /*
  const changeUserLogEmail = (e) => {
    const value = e.target.value;
   // setUserEmail(value);
  }

  */
  useEffect(() => {

    //let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)useremail\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    //setUserEmail(cookieValue);
    
  });


  

  return (
    <ThemeProvider theme={theme}>
        
        <UserContext.Provider value={{userEmail,setUserEmail}}>
            <CssBaseline />
            <div className="">   
                <BrowserRouter>
                    <div className="App">   
                    
                    </div>
                  <Menu  />
                  <Myroutes  />
                  
                    
                </BrowserRouter>    
                  
            </div>

              <Footer /> 
            

        </UserContext.Provider>
    </ThemeProvider>
  );
}


